/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/CustomResource/Content/Content/CustomResource/Content/Resource/Trigger/Status"
  
}) {
let customResourceStatusTypeValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusType',
})
let customResourceStatusTextValueData = fromData.useDataFormat({ viewPath,
context: 'custom_resource',
path: 'statusText',
format: fromFormat.toSentenceCase,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 data="custom_resource.statusType"
 size="normal"
 type={customResourceStatusTypeValueData}
 style="filled"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="custom_resource.statusText"
 format="/Data/format.js toSentenceCase"
 text={customResourceStatusTextValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}